import { Badge, Loader, Tooltip } from '@cowbell/ui';

interface ActiveRunCountBadgeProps {
  readonly count: number;
  /** `count` — compact drawer/sidebar chip. `running` — header "N running" chip. */
  readonly variant?: 'count' | 'running';
}

/** Spinner badge for conversations with in-flight background async runs. */
export default function ActiveRunCountBadge(props: ActiveRunCountBadgeProps) {
  if (props.count <= 0) return null;

  const isRunning = props.variant === 'running';

  return (
    <Tooltip
      label={
        isRunning
          ? `${props.count} background process(es) running in this chat`
          : `${props.count} background process(es) running`
      }
      zIndex={1400}
    >
      <Badge
        size={isRunning ? 'sm' : 'xs'}
        color="blue"
        variant="light"
        radius="sm"
        leftSection={<Loader size={8} color="blue" />}
      >
        {isRunning ? `${props.count} running` : props.count}
      </Badge>
    </Tooltip>
  );
}
